import React from "react";

const UserSuggestionsDropdown = ({
  visible,
  suggestions = [],
  onSelect,
  renderItem,
}) => {
  if (!visible || suggestions.length === 0) return null;

  return (
    <div className="suggestions-dropdown">
      {suggestions.map((item) => (
        <div
          key={item.id}
          className="suggestion-item"
          onClick={() => onSelect(item)}
        >
          {renderItem ? (
            renderItem(item)
          ) : (
            <>
              <div className="suggestion-name">
                {item.first_name} {item.last_name}
              </div>
              <div className="suggestion-email">{item.email}</div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default UserSuggestionsDropdown;